import { render, staticRenderFns } from "./serviceProjectList.vue?vue&type=template&id=64422d2e&scoped=true&"
import script from "./serviceProjectList.vue?vue&type=script&lang=js&"
export * from "./serviceProjectList.vue?vue&type=script&lang=js&"
import style0 from "./serviceProjectList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./serviceProjectList.vue?vue&type=style&index=1&id=64422d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64422d2e",
  null
  
)

component.options.__file = "serviceProjectList.vue"
export default component.exports